import SubscriptionPaymentDetails from './subscriptionPaymentDetails'
export default SubscriptionPaymentDetails
